<template>
    <div class="BillingRoles">
        <h2>Current Billing Roles <span @click="NewRecordShow()" class="pointer"><i class="fa fa-plus olive-green-text" /></span></h2>
        <table class="table-utility">
            <thead>
                <tr>
                    <th>Id</th>
                    <th>Location</th>
                    <th>Billing Role</th>
                    <th>Start Date</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="td in TableData" v-if="td.EndDate == null">
                    <td><span @click="EditRecordShow(td)" class="link-like">{{ td.Id }}</span></td>
                    <td>{{ ConvertSubProgramIDToLocationName(td.Location) }}</td>
                    <td>{{ td.BillingRole }}</td>
                    <td>{{ td.StartDate }}</td>
                </tr>
            </tbody>
        </table>
        <h2>Prior Billing Roles</h2>
        <table class="table-utility">
            <thead>
                <tr>
                    <th>Id</th>
                    <th>Location</th>
                    <th>Billing Role</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="td in TableData" v-if="td.EndDate != null">
                    <td><span @click="EditRecordShow(td)" class="link-like">{{ td.Id }}</span></td>
                    <td>{{ ConvertSubProgramIDToLocationName(td.Location) }}</td>
                    <td>{{ td.BillingRole }}</td>
                    <td>{{ td.StartDate }}</td>
                    <td>{{ td.EndDate }}</td>
                </tr>
            </tbody>
        </table>


        <!--MODALS-->
        <b-modal size="lg" ref="modal-edit" title="Billing Role Details" hide-footer>
            <b-container>
                <b-form @submit="SaveRecord">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Contract:</label>
                                <select class="form-control" v-model="TargetRecord.Location" required>
                                    <option value="12E83DA9-E178-4DB2-9077-6097F277443A">Wraparound</option>
                                    <option value="41870532-AB7A-445B-A690-733150960EBF">Residential</option>
                                    <option value="28CD87C1-85B2-4B3B-B348-8ED0688B7F15">Desert Outpatient</option>
                                    <option value="CBC3D45D-E45C-4BD5-887F-5AB87F154038">Midcounty Outpatient</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Billing Role:</label>
                                <select class="form-control" v-model="TargetRecord.BillingRole" required>
                                    <option v-for="option in BillingRoleOptions" :value="option.value">
                                        {{ option.text }}
                                    </option>
                                </select>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Start Date:</label>
                                <flat-pickr v-model="TargetRecord.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>End Date:</label>
                                <flat-pickr v-model="TargetRecord.EndDate" class="form-control" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="EditRecordCancel()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                            <b-button v-if="TargetRecord.Id" size="md" variant="danger" type="button" @click="DeleteRecord()">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    //import icons


    //mixins

    export default {
        name: "BillingRoles",
        props: [
            "EmployeeId"
        ],
        data: function () {
            return {
                TableData: [],
                TargetRecord: {},
                Filters: {
                    EmployeeID: this.EmployeeId
                },
                
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                },
            };
        },
        methods: {

            //////////////////////////
            //  API CONNECTIONS
            //////////////////////////

            //Get Records
            GetData() {
                this.$MasterAPI.ExecuteRequest("GET", "MentalHealth/Billing/ProviderRoles", this.Filters, this.GetDataSuccess, () => { }, true);
            },
            GetDataSuccess(response) {
                this.TableData = response.data.data;
            },
            //Save Record
            SaveRecord(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "MentalHealth/Billing/ProviderRoles", this.TargetRecord, this.SaveRecordSuccess, () => { }, true);
            },
            SaveRecordSuccess(response) {
                this.GetData();
                this.$refs["modal-edit"].hide();
            },
            //Delete Invoice
            DeleteRecord() {
                this.$MasterAPI.ExecuteRequest("DELETE", "MentalHealth/Billing/ProviderRoles/" + this.TargetRecord.Id, {}, this.DeleteRecordSuccess, () => { }, true);
            },
            DeleteRecordSuccess(response) {
                this.GetData();
                this.$refs["modal-edit"].hide();
            },

            //////////////////////////
            //  MODAL CONTROLLS
            //////////////////////////
            EditRecordShow(record) {
                this.TargetRecord = JSON.parse(JSON.stringify(record));
                this.$refs["modal-edit"].show();
            },
            NewRecordShow() {
                this.TargetRecord = {
                    EmployeeID: this.EmployeeId
                };
                this.$refs["modal-edit"].show();
            },
            EditRecordCancel() {
                this.$refs["modal-edit"].hide();
            },

            //////////////////////////
            //  MISC METHODS
            //////////////////////////
            formatDate(value, fmt = 'MM/DD/YY', defaultVal = '') {
                return (value == null)
                    ? defaultVal
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            ConvertSubProgramIDToLocationName(subProgramID) {
                switch (subProgramID.toUpperCase()) {
                    case "12E83DA9-E178-4DB2-9077-6097F277443A":
                        return "Wraparound";
                    case "41870532-AB7A-445B-A690-733150960EBF":
                        return "Residential";
                    case "28CD87C1-85B2-4B3B-B348-8ED0688B7F15":
                        return "Outpatient"
                }
            }
        },
        components: {
            flatPickr
        },
        computed: {
            BillingRoleOptions: function () {
                return this.$store.state.Options.MentalHealthBillingRoles;
            },
        },
        mounted() {
            this.GetData();
        }
    }
</script>